<template>
    <div class="py-3">
        <b-alert v-if="error" show variant="danger" class="mb-3">{{ error }}</b-alert>
        <b-alert v-if="success" show variant="success" class="mb-3">{{ success }}</b-alert>

        <b-form @submit.prevent="submitSwap">
            <div class="row">
                <div class="col-12 col-md-4">
                    <label class="akkurate-dark small d-none d-lg-block" for="loanNumber">Loan Number</label>
                    <b-form-group label-for="loanNumber" class="akkurate-dark">
                        <b-form-input id="loanNumber" class="mt-2 field-container fields"
                            v-model.trim="form.loan_number" disabled></b-form-input>
                    </b-form-group>
                </div>

                <div class="col-12 col-md-4">
                    <label class="akkurate-dark small d-none d-lg-block" for="targetCustomer">Target Customer
                        Code/Mobile/AC.NO</label>
                    <b-form-group label-for="member" class="mb-3">
                        <b-form-input id="member" v-model="form.code" @input="onInput" name="member"
                            class="mt-2 field-container fields" type="text"
                            placeholder="Eg. Old Code, New Code, Mobile #, First name, Last name"></b-form-input>
                        <!-- <b-form-invalid-feedback >
                               The Balance field is required
                           </b-form-invalid-feedback> -->
                    </b-form-group>
                </div>

                <div class="col-12 col-md-4">
                    <label class="akkurate-dark small d-none d-lg-block" for="teller">Target Account <star></star>
                    </label>
                    <b-form-group label-for="teller" class="mb-3">
                        <multiselect class="mt-2 field-container" v-model="form.selected_account" :options="products"
                            label="name" track-by="account_number" @input="accountSelected"
                            placeholder="Select account">
                        </multiselect>
                        <b-form-invalid-feedback>
                            The Balance field is required
                        </b-form-invalid-feedback>
                    </b-form-group>
                </div>

                <div class="col-12">
                    <label class="akkurate-dark small d-none d-lg-block">&nbsp;</label>
                    <div class="d-grid gap-2 d-flex align-content-center justify-content-start mt-2">
                        <b-button type="submit" :disabled="isSwapping"
                            class="akkurate-green-btn akkurate-auth-size d-flex align-items-center">
                            <font-awesome-icon v-if="!isSwapping" :icon="['fas', 'exchange-alt']" class="me-2" />
                            <b-spinner v-else small class="me-2" />
                            <span>Swap</span>
                        </b-button>
                    </div>
                </div>
            </div>
        </b-form>

        <hr />
        <div class="small text-muted">
            Notes:
            <ul class="mb-0">
                <li>Swapping assigned the loan to an different customer/ Member</li>
                <li>All loan transactions are reassigned to the target member/account.</li>
                <li>The target account must belong to the target customer.</li>
            </ul>
        </div>
    </div>
</template>

<script>
import ApiService from '@/core/services/api.service';
import Multiselect from "vue-multiselect";

export default {
    name: 'LoanSwap',
    props: ['loan_number'],
    components: {
        Multiselect,
    },
    data() {
        return {
            form: {
                loan_number: this.loan_number || '',
                selected_account: null,
                target_account_number: null,
                code: null
            },
            isSwapping: false,
            error: '',
            success: '',
            products: [],
        }
    },
    watch: {
        loan_number(nv) {
            this.form.loan_number = nv || '';
        }
    },
    methods: {
        async submitSwap() {
            this.error = '';
            this.success = '';
            if (!this.form.loan_number || !this.form.target_account_number) {
                this.error = 'Please provide loan number, target customer ID and target account ID.';
                return;
            }
            try {
                this.isSwapping = true;

                swal.fire({
                    title: "Please confirm",
                    html: `Are you sure you want to <strong>SWAP</strong> Loan - : <strong>${this.form.loan_number}</strong> To: <strong>${this.form.customer_name}</strong>`,
                    icon: "info",
                    allowOutsideClick: true,
                    allowEscapeKey: true,
                    showCancelButton: true, // Show the "Cancel" button
                    confirmButtonText: "Merge", // Customize the text for the "OK" button
                    cancelButtonText: "No", // Text for the custom button
                    buttonsStyling: false, // Disable SweetAlert2 styling for buttons
                    customClass: {
                        confirmButton:
                            "btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
                        cancelButton:
                            "btn btn-size akkurate-gray-btn modal-btn-width text-white", // Custom class for the custom button
                    },
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        this.$Progress.start();
                        const { data } = await ApiService.post('/loans/swap', {
                            loan_number: this.form.loan_number,
                            target_account_number: this.form.target_account_number,
                        });
                        if (data?.status === 'success') {
                            this.success = data?.message || 'Loan swapped successfully';
                            this.$bvToast && this.$bvToast.toast(this.success, { variant: 'success', autoHideDelay: 4000 });
                            this.$emit('loanSwapped');
                        } else {
                            throw new Error(data?.message || 'Failed to swap loan');
                        }
                    }
                });
            } catch (e) {
                const msg = e?.response?.data?.message || e?.message || 'Failed to swap loan';
                this.error = msg;
                this.$bvToast && this.$bvToast.toast(msg, { variant: 'danger', autoHideDelay: 5000 });
            } finally {
                this.isSwapping = false;
            }
        },
        onInput(input) {
            console.log(input);
            if (input) {
                clearTimeout(this.debounceTimer);
                this.debounceTimer = setTimeout(this.fetchProducts, 1000);
            } else {
                this.products = [];
            }
        },
        async fetchProducts() {
            await ApiService.post("/accounts/paginate", {
                page: 1,
                per_page: 10,
                filter: this.form.code,
                // branch_id: "",
                account_type_id: "",
                account_number: "",
                // phone_number: this.form.code,
                status: "", //Inactive,	Active, Dormant, Closed
            })
                .then((response) => {
                    if (response.data.data.length > 0) {
                        this.form.customer_name =
                            response.data?.data[0]?.customer?.first_name +
                            " " +
                            response.data?.data[0]?.customer?.last_name;
                        this.form.customer_mobile =
                            response.data?.data[0]?.customer.mobile;
                        this.products = response.data.data.map((index) => {
                            return {
                                id: index.id,
                                product_name: index?.account_type?.name,
                                name: index.account_number + " - " + index?.account_type?.name + " - " + index?.customer?.first_name + " " + index?.customer?.last_name,
                                product_type: index?.account_type?.name,
                                account_number: index?.account_number,
                                customer_name: index?.customer?.first_name + " " + index?.customer?.last_name,
                                customer_mobile: index?.customer?.mobile,
                            };
                        });
                    } else {
                        this.products = [];
                        // swal.fire({
                        //   icon: "error",
                        //   title: "Not Found",
                        //   text: "This account was not found please try again!!!",
                        //   showCancelButton: false, // Show the "Cancel" button
                        //   confirmButtonText: "OK", // Customize the text for the "OK" button
                        //   buttonsStyling: false, // Disable SweetAlert2 styling for buttons
                        //   customClass: {
                        //     confirmButton:
                        //       "btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
                        //   },
                        //   // footer: '<a href="#">Why do I have this issue?</a>'
                        // });
                    }
                    //   this.is_searching = false;
                    //   this.search_btn = "Search";
                })
                .catch((error) => {
                    //   this.is_searching = false;
                    //   this.search_btn = "Search";
                });
        },
        // accountSelected(accnt) {
        //     console.log(accnt);
        //     this.form.customer_name = accnt.customer_name;
        //     this.form.customer_mobile = accnt.customer_mobile;
        //     this.form.product_name = accnt.product_name;
        //     this.form.target_account_number = accnt.account_number;

        // },
        accountSelected(selected) {
            // selected is either the object or null (when cleared)
            if (selected) {
                this.form.customer_name = selected.customer_name;
                this.form.customer_mobile = selected.customer_mobile;
                this.form.product_name = selected.product_name;
                this.form.target_account_number = selected.account_number;
            } else {
                this.form.customer_name = null;
                this.form.customer_mobile = null;
                this.form.product_name = null;
                this.form.target_account_number = null;
            }
        }
    }
}
</script>
